export const LIMIT_TOTAL_DISPLAY = 250;
export const MAX_RESULTS = 20;
